import type { FaireBrandEntity } from "../../entity_types/brand";

// Anonymized stand-in for the p1_floor_budget archetype (real metrics, fake identity).
export const bAdvP1FloorBudget: FaireBrandEntity = {
  token: "b_adv_p1_floor_budget",
  type: "brand",
  name: "Copper Kettle Confections",
  description: "Small-batch peanut brittle and caramel corn",
  location: "Austin, TX",
  rating: 4.6,
  minimumOrderDollars: 100,
  tags: ["candy", "small-batch", "gifts"],
  meta: {
    source: "mock",
    importedAt: "2026-07-06T00:00:00.000Z",
    importedBy: "advertiser-profiles",
  },
};
